import React, {useContext, useRef} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import httpAPI from '@mirinae/lessons/editor/modules/apis/http';
import { apiPaths, apiServer } from '@mirinae/shared/defines/paths';
import Box, { Row } from './Box';
import styled from "styled-components";

//     setLesson: '/api/pattern/setlesson',
//     getPageOfPatterns: '/api/pattern/getpageof',

const PatternLink = styled.a`
    font-size: 10px;
    color: blue;
    align-self: flex-end;
    margin: 5px;
`;

const SelectGrammarPattern = ({ setPattern }) => {
    const [open, setOpen] = React.useState(false);
    const [patterns, setPatterns] = React.useState([]);
    const searchKey = useRef('');
    const loading = open && patterns.length === 0 && searchKey.current !== '';

    React.useEffect(() => {
        if (!open) {
            setPatterns([]);
        }
    }, [open]);

    const onSearchKeyChanged = (e, reason) => {
        searchKey.current = e.target.value;
        const options = {
            data: {
                page: 1,
                itemsPerPage: 100,
                sortBy: '',
                sortDesc: false,
                search: e.target.value,
                typeFilter: 'Non-corrections'
            },
        };
        setPatterns([]);
        setPattern(null);

        httpAPI(apiServer, apiPaths.getPageOfPatterns, options)
            .then(data => {
                setPatterns(data.patterns);
            });
    };

    const selectPattern = (pattern) => {
        httpAPI(apiServer, apiPaths.getPattern, { data: { id: pattern.id } })
            .then(data => {
                setPattern({ ...pattern, ...data });
            });
    };

    return (
        <Box>
            <Row justify="space-between">
                <Autocomplete
                    style={{ width: '100%' }}
                    open={open}
                    onOpen={() => { setOpen(true); }}
                    onClose={() => { setOpen(false); }}
                    getOptionLabel={(p) => `${p.title}, ${p.referenceDef}`}
                    options={patterns}
                    noOptionsText="Key in pattern search"
                    loading={loading}
                    onInputChange={onSearchKeyChanged}
                    onChange={(e, pat) => selectPattern(pat)}
                    renderInput={(params) => (
                        <TextField
                            { ...params }
                            label="Select pattern"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                />
            </Row>
        </Box>
    );
};

export default SelectGrammarPattern;

